import FadeIn from './FadeIn';

export const works = [
  {
    type: 'Mix — Afro House',
    title: 'HOL 2602',
    desc: 'A journey through warm low-end textures, spiritual tension, and jazz-inflected percussion. Eighty minutes of deliberate movement.',
    tracks: [
      { name: 'HOL 2602 – Afro House:Tech Mix', url: 'https://soundcloud.com/lulo_lonke/hol-2602-afro-house-tech-mix' },
    ],
  },
  {
    type: 'Production — Original',
    title: 'Original Work',
    desc: 'Studio productions drawing from township memory, electronic architecture, and the improvisational spirit of South African jazz.',
    tracks: [
      { name: 'Nyknyk Engaka', url: 'https://soundcloud.com/lulo_lonke/lulo-lonke-nyknyk-engaka' },
      { name: "Yebba's Heartbreak (Cover)", url: 'https://soundcloud.com/lulo_lonke/yebbas-heartbreak-lulo-lonke' },
      { name: 'Thula – Lulo Lonke Cover', url: 'https://soundcloud.com/lulo_lonke/bongeziwe-mabandla-thula-lulo' },
    ],
  },
  {
    type: 'Live — Performance',
    title: 'Live Sets',
    desc: 'Club performances and curated sets that move between the intimate and the euphoric — always narrative-led, never predictable.',
    tracks: [
      { name: 'Thula – Lulo Lonke Cover', url: 'https://soundcloud.com/lulo_lonke/bongeziwe-mabandla-thula-lulo' },
    ],
  },
];

export default function Sound({ nowPlaying, onPlay }) {
  const togglePlayer = (workIndex) => {
    if (nowPlaying?.workIndex === workIndex) {
      onPlay(null);
    } else {
      onPlay({ workIndex, trackIndex: 0 });
    }
  };

  return (
    <section id="sound" data-testid="sound-section">
      <div className="section-inner">
        <FadeIn>
          <div className="sound-header">
            <div>
              <div className="section-label">02 — Featured Sound</div>
              <h2 className="sound-title display">Selected Works</h2>
            </div>
          </div>
        </FadeIn>
        <FadeIn delay={0.15}>
          <div className="sound-cards">
            {works.map((w, i) => {
              const isActive = nowPlaying?.workIndex === i;
              return (
                <div
                  key={i}
                  className={`sound-card${isActive ? ' sound-card--active' : ''}`}
                  data-testid={`sound-card-${i}`}
                >
                  <div className="sound-card-type">{w.type}</div>
                  <div className="sound-card-title display">{w.title}</div>
                  <div className="sound-card-desc">{w.desc}</div>
                  {w.tracks.length > 1 && (
                    <div className="sound-card-tracks" data-testid={`track-count-${i}`}>
                      {w.tracks.length} tracks
                    </div>
                  )}
                  <button
                    className={`play-icon${isActive ? ' play-icon--active' : ''}`}
                    onClick={() => togglePlayer(i)}
                    aria-label={isActive ? `Stop ${w.title}` : `Play ${w.title}`}
                    data-testid={`play-icon-${i}`}
                  >
                    {isActive ? (
                      <svg width="10" height="12" viewBox="0 0 10 12">
                        <rect x="0" y="0" width="3" height="12" fill="currentColor" />
                        <rect x="7" y="0" width="3" height="12" fill="currentColor" />
                      </svg>
                    ) : (
                      <svg width="10" height="12" viewBox="0 0 10 12">
                        <polygon points="0,0 10,6 0,12" fill="currentColor" />
                      </svg>
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
